<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="2">
        <v-select :items="logLevels" label="Log level" v-model="logLevel">
        </v-select>
      </v-col>
      <v-col cols="10" md="3">
        <v-text-field label="End time" v-model="logsEndTime"> </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn
          class="mt-2 ml-0"
          color="blue"
          dark
          small
          @click="logsEndTimeNow()"
        >
          <v-icon dark> mdi-arrow-down-circle-outline </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="5">
        <v-radio-group v-model="logTimeRange" row>
          <v-radio label="5 min" value="5"></v-radio>
          <v-radio label="15 min" value="10"></v-radio>
          <v-radio label="1 h" value="60"></v-radio>
          <v-radio label="24 h" value="1440"></v-radio>
          <v-radio disabled label="custom" value="0"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn color="primary" @click="getLogs()" style="min-width: 100px"
          >Run</v-btn
        >
      </v-col>
      <v-col cols="12" v-if="logsError">
        <p class="red--text">
          {{ logsError }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="logs"
          :items-per-page="10"
          :expanded.sync="logsExpanded"
          item-key="Id"
          :loading="logsLoading"
          loading-text="Loading..."
          show-expand
          class="elevation-1"
        >
          <template v-slot:[`item.HighestSeverity`]="{ item }">
            <v-chip
              x-small
              chip
              :color="severityAsColor(item.HighestSeverity)"
            >
              {{ severityAsString(item.HighestSeverity) }}
            </v-chip>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="background-color: lightgrey">
              <div v-for="(log, i) in item.Logs" :key="i">
                {{ log }}
              </div>
            </td>
          </template>
          <template v-slot:[`item.Ts`]="{ item }">
            {{ $utils.detailedTimeFromTs(item.Ts) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      logsLoading: true,
      logsExpanded: [],
      headers: [
        { text: "id", value: "Id" },
        {
          text: "ts",
          align: "start",
          sortable: true,
          value: "Ts",
        },
        { text: "severity", value: "HighestSeverity" },
        { text: "email", value: "Email" },
        { text: "dusi", value: "Dusi" },
        { text: "device", value: "Device" },
        { text: "events", value: "Events" },
        { text: "", value: "data-table-expand" },
      ],
      logs: [],
      logLevels: ["INFO+", "WARNING+", "ERROR+", "CRITICAL+", "ANY"],
      logLevel: "ERROR+",
      logTimeRange: "5",
      logsEndTime: "",
      logsError: "some error here",
    };
  },
  mounted() {
    this.logsEndTimeNow();
  },
  methods: {
    enteredLogsTab() {
      if (this.logs.length == 0) {
        this.getLogs();
      }
    },
    async getLogs() {
      this.logsLoading = true;
      this.logsError = "";
      try {
        var resp = await this.$utils.callBackendPost(this, "/admin/getLogs", {
          lastId: this.logsLastId,
          errorLevel: this.levelStrToNum(this.logLevel),
          endTime: this.$utils.tsMsFromDetailedTime(this.logsEndTime),
          range: Number(this.logTimeRange),
        });
        console.log("response: " + JSON.stringify(resp, null, 2));
        this.logs = resp;
        if (this.logs.length > 0) {
          this.logsLastId = this.logs[this.logs.length - 1].id;
        } else {
          this.logsLastId = "";
        }
      } catch (error) {
        this.logsError = error;
      } finally {
        this.logsLoading = false;
      }
    },
    severityAsString(severity) {
      switch (severity) {
        case 0:
          return "CRITICAL";
        case 1:
          return "ERROR";
        case 2:
          return "WARNING";
        case 3:
          return "INFO";
        default:
          return "UNKNOWN";
      }
    },
    severityAsColor(severity) {
      switch (severity) {
        case 0:
          return "purple lighten-2";
        case 1:
          return "red lighten-2";
        case 2:
          return "orange lighten-2";
        case 3:
          return "green lighten-2";
        default:
          return "grey lighten-2";
      }
    },
    logsEndTimeNow() {
      const now = new Date();
      this.logsEndTime = this.$utils.detailedTimeFromTs(now.getTime()); // gets epoch time in ms
      console.log("burny! logsEndTime: " + this.logsEndTime);
    },
    levelStrToNum(level) {
      switch (level) {
        case "INFO+":
          return 3;
        case "WARNING+":
          return 2;
        case "ERROR+":
          return 1;
        case "CRITICAL+":
          return 0;
        default:
          return 100;
      }
    },
  },
};
</script>
